import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteClothIssue } from '../../../Store/PHPSlice/Cutting/clothIssue';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import axios from 'axios';
import { fetchStitchingReturnlist } from '../../../Store/PHPSlice/Stitching/StitchApi';

const TableBody = ({
    serialNumber,
    id,
    dt,
    stId,
    reMemo,
    firmId,
    firmNm,
    stMemo,
    sono,
    orderno,
    empNm,
    itemNm,
    totQty,
    reQty,
    totmat,
    remat,
    sts,
    k_sts,
    pay_sts,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const handleDeleteClick = () => {
        // Show confirmation dialog

        const isConfirmed = window.confirm("Are you sure you want to delete this Stitching Inward?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            deleteStitchingInw(id)
        }


    };

    const deleteStitchingInw = async (id) => {
        try {
            const res = await axios.delete(`${baseUrl}?apicall=deleteStitchingInwardReg&stInwId=${id}`);
            // console.log(res);
            const msg = res?.data;

            alert(msg.msg);

            dispatch(fetchStitchingReturnlist());
        } catch (error) {
            console.error("Error deleting Item:", error);
        }
    };

    const handleViewClick = () => {
        window.open(`/StitchReturnInfo/${stId}`, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');
    };


    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {stMemo}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sono}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {orderno}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {empNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {itemNm}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {totQty}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {reQty}
                </TableCell>


                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {totmat}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {remat}
                </TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} />
                </TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${(pay_sts === '1' || k_sts === '1') ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
